import { OptionSchema } from "@schema-types/types/JourneySchema";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CircleCheck } from "lucide-react";

// Based this input on https://www.shadcnui-blocks.com/components/checkbox

interface CheckboxCardProps {
  options: OptionSchema[];
  defaultValue?: string[];
  value?: string[];
  onCheckedChange: (checked: boolean, option: OptionSchema) => void;
  disabled?: boolean;
}

const CheckboxCard = ({ options, defaultValue, value, onCheckedChange, disabled }: CheckboxCardProps) => {
  return (
    <div className="grid w-full max-w-sm grid-cols-3 gap-3">
      {options.map((option) => (
        <CheckboxPrimitive.Root
          key={option.value}
          onCheckedChange={(checked) => onCheckedChange(checked as boolean, option)}
          defaultChecked={defaultValue?.includes(option.value)}
          checked={value?.includes(option.value)}
          disabled={disabled}
          className="relative rounded px-4 h-10 text-sm text-start ring-[1px] ring-border data-[state=checked]:ring-2 data-[state=checked]:ring-ring disabled:opacity-50"
        >
          <span className="tracking-tight">{option.label}</span>

          <CheckboxPrimitive.Indicator className="absolute right-2 top-2">
            <CircleCheck className="fill-ring text-primary-foreground" />
          </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
      ))}
    </div>
  );
};

export default CheckboxCard;

